import { createSlice } from '@reduxjs/toolkit'

export const memberSlice = createSlice({
  name: 'member',
  initialState: {
    value: false,
  },
  reducers: {
    setMember: (state,action) => {
      state.value = true
    },
    clearMember: (state,action) => {
      state.value = false
    },
  },
})

export const { setMember,clearMember} = memberSlice.actions

export default memberSlice.reducer